'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Tabs = require('../Tabs.js');

var useTabs = function () {
    var context = React.useContext(Tabs.TabsContext);
    if (!context) {
        throw new Error('This component must be used within the <Tabs> component.');
    }
    return context;
};

exports.useTabs = useTabs;
//# sourceMappingURL=useTabs.js.map
